import { MultiProvider } from '@openfeature/web-sdk'

import { fliptProvider } from './flipt'

export const multiProvider = new MultiProvider([
	{
		provider: fliptProvider,
	},
])
